import { FormField } from 'src/components/molecules/FormField'

import { FormFieldTypes } from 'src/types/form'

import { schoolTypeOptions } from '../../helper'

export interface SchoolTertiaryProps {}

export const SchoolTertiary = () => {
  return (
    <FormField
      id='SchoolType'
      label='School type'
      options={schoolTypeOptions}
      type={FormFieldTypes.select}
    />
  )
}
